// ============================================================
// markers.jsx — Pastille colorée affichée sur la carte Google Maps
// Chaque parc est représenté par un cercle dont la couleur
// indique l'état de contrôle (vert/orange/rouge/violet).
// Ce composant est positionné par google-map-react via lat/lng.
// ============================================================

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Composant styled-components : cercle positionné en absolu
// La couleur de fond dépend de la prop "color" (code entier) :
//   3 → violet (standby), 0 → rouge (urgent), 2 → orange, autre → vert
const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 18px;
  height: 18px;
  background-color: ${(props) =>
    props.color === 3 ? 'purple' :
    (props.color === 0 ? 'red' :
    (props.color === 2 ? 'orange' : 'green'))};
  border: 1px solid #fff;
  border-radius: 100%;       /* Forme circulaire */
  user-select: none;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  &:hover {
    z-index: 1; /* Passe au-dessus des autres pastilles au survol */
  }
`;

// Composant Marker : rendu de la pastille sur la carte
// Props reçues depuis MapApp.js :
//   text         — nom du parc (pour l'attribut alt)
//   onClick      — ouvre la modale de contrôle au clic
//   isControlled — état de contrôle (non utilisé directement ici)
//   color        — code couleur (0=rouge, 1=vert, 2=orange, 3=violet)
const Marker = ({ text, onClick, isControlled, color }) => (
  <Wrapper
    alt={text}
    onClick={onClick}
    isControlled={isControlled}
    color={color}
  />
);

// Valeur par défaut : pas de handler de clic
Marker.defaultProps = {
  onClick: null,
};

// Validation des props
Marker.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
};

export default Marker;
